import { render, staticRenderFns } from "./manualPage.vue?vue&type=template&id=b7571ae2"
import script from "./manualPage.vue?vue&type=script&lang=js"
export * from "./manualPage.vue?vue&type=script&lang=js"
import style0 from "./manualPage.vue?vue&type=style&index=0&id=b7571ae2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7571ae2')) {
      api.createRecord('b7571ae2', component.options)
    } else {
      api.reload('b7571ae2', component.options)
    }
    module.hot.accept("./manualPage.vue?vue&type=template&id=b7571ae2", function () {
      api.rerender('b7571ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/menu/manualPage.vue"
export default component.exports